import PropTypes from 'prop-types';
import StakeInput from './stake-input.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Stake input view displaying the stake input for bets.
 *
 * @class StakeInput
 * @memberof Mojito.Modules
 */

/**
 * `StakeInput` prop types.
 *
 * @property {number} [stakeForLine] - The stake for line.
 * @property {string} [placeholderValue] - Placeholder text displayed when the input value is empty.
 * @property {boolean} [disabled = false] - Indicates whether the stake input is disabled.
 * @property {boolean} [hidden = false] - Indicates whether the stake input is visually hidden (but remains present in the DOM).
 * @property {boolean} [showStake = true] - Controls the stake's visibility to the user. `false` hides the stake, `true` displays it.
 * @property {boolean} [showKeyboard = false] - Indicates whether the keyboard should be shown or not.
 * @property {boolean} [isEachWayAvailable = false] - Indicates whether the toggle button is shown.
 * @property {boolean} [isEachWayActivated = false] - Indicates whether the toggle button is selected.
 * @property {boolean} [isValid = true] - Indicates whether the stake is valid.
 * @property {Function} [onFocusCallback = () => {}] - Callback invoked when the stake box gains focus.
 * @property {Function} [onBlurCallback = () => {}] - Callback invoked on the stake input blur.
 * @property {Function} [onStakeChange = () => {}] - Callback invoked on set stake. This call will be triggered with a 500ms debounce delay to make sure that user finalize the choice.
 * @property {Function} [onStakeChangeIntent = () => {}] - Callback invoked immediately after user change the value in the input. Unlike onStakeChange, this callback will be triggered with no debounce delay.
 * @memberof Mojito.Modules.StakeInput
 */
const propTypes = {
    stakeForLine: PropTypes.number,
    placeholderValue: PropTypes.string,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    showStake: PropTypes.bool,
    showKeyboard: PropTypes.bool,
    isEachWayAvailable: PropTypes.bool,
    isEachWayActivated: PropTypes.bool,
    isValid: PropTypes.bool,
    onFocusCallback: PropTypes.func,
    onBlurCallback: PropTypes.func,
    onStakeChange: PropTypes.func,
    onStakeChangeIntent: PropTypes.func,
};

const defaultProps = {
    disabled: false,
    hidden: false,
    showStake: true,
    showKeyboard: false,
    isEachWayAvailable: false,
    isEachWayActivated: false,
    isValid: true,
    onFocusCallback: noop,
    onBlurCallback: noop,
    onStakeChange: noop,
    onStakeChangeIntent: noop,
};

export default UIView('StakeInput', StakeInput, propTypes, defaultProps);
